export default __webpack_public_path__ + "static/media/refeicao.8f59749a.png";